export default __webpack_public_path__ + "media/color/zel-8095f7aa.svg";